import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {infoSourceListUrl} from "~/pages/supplier-360/services/supplier360PdlUrls";
import type {InfoSourceConfig} from "~/pages/supplier-360/types/Supplier360PdlTypes";

/** Every automated provider's own config row — a handful at most, so the first (only) page covers it. */
export function useInfoSourcesQuery() {
    const url = infoSourceListUrl();
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<InfoSourceConfig>>(url)).data.results,
        staleTime: Infinity,
    });
}
